//
//
//
//
//
//
//
//
//
//

export default {
    name: 'YtoRate',
    data() {
        return {
            currentValue: 0,
            length: 5
        };
    },
    props: {
        value: {
            type: Number,
            default: 0
        }
    },
    mounted() {
        this.currentValue = this.value;
    },
    methods: {
        setValue(value) {
            this.currentValue = value,
            this.$emit('change', value);
        },
        getIcon(index) {
            return `static/img/chat/star_${index <= this.currentValue ? 'on' : 'off'}.png`;
        }
    },
    watch: {
        value: function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.currentValue = newValue;
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/yto-rate/index.vue